import React from "react";
import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { useT } from "@/lib/i18n";

const EASE = [0.22, 1, 0.36, 1];

const AVATARS = [
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=160&q=80",
    "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=160&q=80",
    "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?auto=format&fit=crop&w=160&q=80",
];

export default function Testimonials() {
    const { t } = useT();
    const quotes = t("testimonials.quotes") || [];
    return (
        <section data-testid={TID.testimonials.root} className="bg-sn-paper py-24 md:py-40">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="flex items-baseline gap-4 mb-14 md:mb-20"
                >
                    <span className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-blue">
                        {t("testimonials.eyebrow")}
                    </span>
                    <span className="hairline flex-1" />
                    <span className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-ink-2">
                        {t("testimonials.count")}
                    </span>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
                    {quotes.map((q, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }}
                            className="flex flex-col"
                        >
                            <div className="text-sn-blue font-serif text-6xl leading-none mb-4">
                                “
                            </div>
                            <blockquote className="font-serif text-2xl md:text-3xl leading-snug text-sn-ink">
                                {q.text}
                            </blockquote>
                            <figcaption className="mt-6 pt-6 border-t border-black/10 flex items-center gap-4">
                                <img
                                    src={AVATARS[i % AVATARS.length]}
                                    alt={q.author}
                                    loading="lazy"
                                    onError={(e) => {
                                        e.currentTarget.style.display = "none";
                                    }}
                                    className="w-12 h-12 rounded-full object-cover border border-black/10 grayscale"
                                />
                                <div>
                                    <div className="font-mono-e text-[11px] uppercase tracking-[0.24em] text-sn-ink">
                                        {q.author}
                                    </div>
                                    <div className="font-mono-e text-[10px] uppercase tracking-[0.2em] text-sn-ink-2 mt-1">
                                        {q.role}
                                    </div>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
